import { Menu, MenuItem, Popover } from '@mui/material';
import { styled } from '@mui/material';
import { ComponentProps, useState } from 'react';

import { Icon, Typography } from '../..';
import { Filter, Filters } from './Filters';
import { useMenuAnchor } from './UseMenuAnchor';

const IsFilteringWrapper = styled('div')({
  minWidth: '6px',
  display: 'grid',
  placeItems: 'center'
});

type FilterMenuItemProps = {
  filter: Filter;
} & ComponentProps<typeof MenuItem>;

const FilterMenuItem = ({ filter, ...rest }: FilterMenuItemProps) => {
  return (
    <MenuItem
      {...rest}
      sx={{
        display: 'grid',
        gridTemplateColumns: 'max-content 1fr max-content',
        gap: '12px'
      }}
    >
      <IsFilteringWrapper>
        {filter.isFiltering && <Typography fontWeight="fontWeightMedium">·</Typography>}
      </IsFilteringWrapper>
      <div>{filter.name}</div>
      <Icon name="rightArrow" />
    </MenuItem>
  );
};

type FilterMenuProps = {
  filters: Filters;
} & ComponentProps<typeof Menu>;

export const FilterMenu = ({ filters, ...menuProps }: FilterMenuProps) => {
  const { anchorEl, handleClick, handleClose, isOpen } = useMenuAnchor();
  const [filterMenuId, setFilterMenuId] = useState<string>();
  return (
    <>
      <Menu {...menuProps}>
        {Object.entries(filters).map(([id, filter]) => (
          <FilterMenuItem
            key={id}
            onClick={event => {
              handleClick(event);
              setFilterMenuId(id);
            }}
            filter={filter}
            disabled={filter.isLoading}
          />
        ))}
      </Menu>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top'
        }}
      >
        {filterMenuId && filters[filterMenuId]?.menu}
      </Popover>
    </>
  );
};
